/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of PersonasClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfIEnumerable_1OfPersona,
  PostPersonaRequest,
  PutPersonaRequest,
  DeleteRoleFromPersonasResponse,
  Persona,
  UpdateUsersInAuth0Response,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockPersonas: Persona[] = [
  {
    id: 1,
    description: 'Store Manager',
    franchiseName: 'Demo',
    personaRoles: ['StockCountRead', 'StockCountWrite', 'OrdersRead', 'OrdersWrite', 'InvoicesRead'],
    modules: ['StockManagement', 'Ordering', 'Invoicing'],
  },
  {
    id: 2,
    description: 'Store Staff',
    franchiseName: 'Demo',
    personaRoles: ['StockCountRead', 'OrdersRead'],
    modules: ['StockManagement', 'Ordering'],
  },
  {
    id: 3,
    description: 'Admin',
    franchiseName: 'Demo',
    personaRoles: ['Admin', 'UserManagement', 'ConfigurationManagement'],
    modules: ['Administration'],
  },
];

/* ---- Mocked Client Implementation ---- */

import { IPersonasClient } from '../../interfaces';
export class PersonasClientMocked implements IPersonasClient {
  constructor(baseUrl?: string) {}

  async personasGET(franchiseName?: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfIEnumerable_1OfPersona> {
    await delay();
    const personas = franchiseName
      ? mockPersonas.filter((p) => p.franchiseName === franchiseName)
      : mockPersonas;
    return successResponse(personas) as SuccessResponse_1OfIEnumerable_1OfPersona;
  }

  async personasPOST(body?: PostPersonaRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body) {
      mockPersonas.push({
        id: mockPersonas.length + 1,
        description: body.description || 'New Persona',
        franchiseName: body.franchiseName || 'Demo',
        personaRoles: body.personaRoles || [],
        modules: [],
      });
    }
  }

  async personasPUT(id: number, body?: PutPersonaRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const persona = mockPersonas.find((p) => p.id === id);
    if (persona && body) {
      persona.description = body.description || persona.description;
      persona.personaRoles = body.personaRoles || persona.personaRoles;
    }
  }

  async personasDELETE(id: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockPersonas.findIndex((p) => p.id === id);
    if (index > -1) {
      mockPersonas.splice(index, 1);
    }
  }

  async rolesDELETE(roleId: number, dryRun?: boolean, cancelToken?: CancelToken): Promise<DeleteRoleFromPersonasResponse> {
    await delay();
    return {
      affectedPersonas: 2,
      personaNames: ['Store Manager', 'Store Staff'],
    } as DeleteRoleFromPersonasResponse;
  }

  // ====== Auto-generated stub methods ======









    async updateauth0(dryRun?: boolean | undefined, backgroundTask?: boolean | undefined, body?: number[] | undefined, cancelToken?: CancelToken | undefined): Promise<UpdateUsersInAuth0Response> {
        throw new Error('Method updateauth0 not implemented in mocked client');
    }

}
